import React from "react";
import { Link } from "react-router-dom";

const BreadCrumb = props => {
  const { data } = props;
  const arrayLength = data.length;
  const modifiedData = [{ name: "Project", link: "/mobile-view-info-list" }, ...data];

  const liJSX = modifiedData.map((element, i) => {
    if (modifiedData.length === i + 1) {
      // last element
      return (
        <li className="breadcrumb-item active" aria-current="page" key={i}>
          <a>{element.name}</a>
        </li>
      );
    } else {
      // not last element
      return (
        <li className="breadcrumb-item" key={i}>
          {/* <Link to={element.link}> */}
            {/* <a href="" onClick={()=>props.onRemoveBreadCrumb(element, i)}>{element.name}</a> */}
          {/* </Link> */}
          {i === 0 ? ( // Special case for "Project"
            <Link to="/mobile-view-info-list">{element.name}</Link>
          ) : (
            <a href="" onClick={() => props.onRemoveBreadCrumb(element, i - 1)}>
              {element.name}
            </a>
          )}
        </li>
      );
    }
  });
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb" style={{margin:0}}>
        {/* <li className="breadcrumb-item" key={100}>
          <Link to="/home">
            <a>Home</a>
          </Link>
        </li> */}
        {liJSX}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
